module.exports = __webpack_public_path__ + "img/icon-language-white.fa57ba44.svg";